// crawler-user-agents is pinned to v1.60.0: https://github.com/monperrus/crawler-user-agents
// per Datadog's bot-filtering guide: https://docs.datadoghq.com/real_user_monitoring/guide/identify-bots-in-the-ui/#filter-out-bot-sessions-on-intake
import crawlerUserAgents from 'crawler-user-agents';

// "*-User" agents (ChatGPT-User, Claude-User, etc.) fire when a real person asks an AI
// assistant to browse/shop on their behalf — exclude them so we don't zero out real sessions.
// Some agentic patterns don't follow that naming convention, so list them explicitly too.
const agenticUserBotPatterns = new Set([
  'AmazonBuyForMe',
  'Google-Agent',
  'GoogleAgent-Mariner'
]);

const isAgenticUserBot = (pattern: string) =>
  /user$/i.test(pattern) || agenticUserBotPatterns.has(pattern);

const botRegex = new RegExp(
  crawlerUserAgents
    .filter(({ pattern }) => !isAgenticUserBot(pattern))
    .map(({ pattern }) => pattern)
    .join('|'),
  'i'
);

export default function isBotUserAgent(userAgent: string): boolean {
  return botRegex.test(userAgent);
}
